import { useEffect, useState } from 'react';
import { authAPI } from '../../api/apiClient';
import { useUser } from '../../Components/userContext';
import useApi from './useApi';

const useCheckLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { user, setUser } = useUser();
  const { callApi } = useApi();

  const checkLoginStatus = async () => {
    try {
      if (!user) {
        const fetchedUser = await callApi(() => authAPI.checkStatus());
        if (fetchedUser.isAuthenticated) {
          setUser(fetchedUser.user);
        }
      }
    } catch (error) {
      console.error('Błąd podczas sprawdzania stanu logowania:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkLoginStatus();
  }, []);

  return isLoading;
};

export default useCheckLogin;
